import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ShopSection = () => {
  const [products, setProducts] = useState([]);
  const [grid, setGrid] = useState(false);
  const [active, setActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const navigate = useNavigate();

  // ✅ Fetch products on mount
  useEffect(() => {
    fetch("/assets/data/brother-products.json")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
      })
      .catch((err) => console.error("Error loading products:", err));
  }, []);

  // ✅ Show Thank You after 5 seconds when downloading starts
  useEffect(() => {
    if (downloading) {
      const timer = setTimeout(() => setShowThankYou(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [downloading]);

  // ✅ Add to Cart Handler
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  // ✅ Download button click handler
  const handleDownload = (e) => {
    e.preventDefault();
    setShowModal(false);
    setDownloading(true);
  };

  // ✅ Default Page
  return (
    <section className="shop">
      {/* 🔹 Product Grid Section */}
      <div className="container container-lg mt-40 mb-40">
        <div className="row">
          <div className="col-lg-12">
            <div className="flex-between gap-16 flex-wrap mb-40">
              <span className="text-gray-900">
                Showing 1–{products.length} of {products.length} results
              </span>
            </div>

            <div className={`list-grid-wrapper ${grid && "list-view"}`}>
              <div className="row gy-4">
                {products.map((item) => {
                  const rating = (Math.random() * 1 + 4).toFixed(1);
                  const reviews = Math.floor(Math.random() * 900) + 100;
                  const randomTags = [
                    "Office Printer",
                    "Home Printer",
                    "Best Seller",
                    "Inkjet",
                    "Laser",
                    "Wireless",
                    "Fast Printing",
                  ];

                  // pick 3 random tags
                  const features = randomTags
                    .sort(() => 0.5 - Math.random())
                    .slice(0, 3);

                  return (
                    <div className="col-sm-3" key={item.id}>
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: "18px",
                          overflow: "hidden",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          transition: "transform 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.transform = "translateY(-6px)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.transform = "translateY(0)")
                        }
                      >
                        <Link to={`/product/${item.id}`}>
                          {/* IMAGE */}
                          <div
                            style={{
                              width: "100%",
                              padding: "15px 15px 0 15px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                            }}
                          >
                            <img
                              src={
                                item.imageUrl ||
                                "/assets/images/thumbs/product-two-img1.png"
                              }
                              alt={item.name}
                              style={{
                                width: "75%",
                                height: "auto",
                                objectFit: "contain",
                                padding: "8px",
                              }}
                            />

                            {/* HOT SALE BADGE */}
                            <div
                              style={{
                                position: "absolute",
                                top: "8px",
                                right: "18px",
                                background: "#ff4d4f",
                                color: "#fff",
                                padding: "6px 12px",
                                fontSize: "11px",
                                fontWeight: "700",
                                borderRadius: "20px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                              }}
                            >
                              HOT SALE
                            </div>
                          </div>
                        </Link>

                        {/* CONTENT */}
                        <div style={{ padding: "20px" }}>
                          {/* CATEGORY */}
                          <p
                            style={{
                              fontSize: "11px",
                              letterSpacing: "1px",
                              fontWeight: "600",
                              color: "#777",
                              marginBottom: "6px",
                              textTransform: "uppercase",
                            }}
                          >
                            {(item.category || "High Performance").replace(
                              /-/g,
                              " "
                            )}
                          </p>

                          {/* TITLE */}
                          <Link
                            to={`/product/${item.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            <h3
                              style={{
                                fontSize: "20px",
                                fontWeight: "800",
                                marginBottom: "10px",
                                color: "#111",
                              }}
                            >
                              {item.name}
                            </h3>
                          </Link>

                          {/* DESCRIPTION */}
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#555",
                              lineHeight: "1.6",
                              marginBottom: "14px",
                            }}
                          >
                            {item.description
                              ?.split(" ")
                              .slice(0, 16)
                              .join(" ") +
                              (item.description?.split(" ").length > 16
                                ? "..."
                                : "")}
                          </p>

                          {/* ⭐ TAGS WORKING NOW */}
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              gap: "6px",
                              marginBottom: "18px",
                              paddingBottom: "4px",
                            }}
                          >
                            {features.map((tag, index) => (
                              <span
                                key={index}
                                style={{
                                  fontSize: "10px",
                                  background: "#eef5ff",
                                  padding: "5px 10px",
                                  borderRadius: "8px",
                                  color: "#2694e9",
                                  whiteSpace: "nowrap",
                                  fontWeight: "600",
                                }}
                              >
                                {tag}
                              </span>
                            ))}
                          </div>

                          {/* PRICE + ADD TO CART */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "20px",
                            }}
                          >
                            <div>
                              {item.oldPrice && (
                                <div
                                  style={{
                                    fontSize: "14px",
                                    color: "#999",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  ${item.oldPrice}
                                </div>
                              )}

                              <div
                                style={{
                                  fontSize: "24px",
                                  fontWeight: "800",
                                  color: "#111",
                                }}
                              >
                                ${item.price}
                              </div>
                            </div>

                            <button
                              onClick={() => handleAddToCart(item)}
                              style={{
                                background: "#2694e9",
                                border: "none",
                                padding: "10px 18px",
                                borderRadius: "8px",
                                color: "#fff",
                                fontWeight: "700",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "0 4px 12px rgba(38,148,233,0.4)",
                                transition: "background 0.3s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background = "#1f83cc")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background = "#2694e9")
                              }
                            >
                              Add to Cart
                              <i
                                className="ph ph-shopping-cart"
                                style={{ fontSize: "18px" }}
                              />
                            </button>
                          </div>

                          {/* DIVIDER */}
                          <div
                            style={{
                              width: "100%",
                              height: "1px",
                              background: "#e8e8e8",
                              marginBottom: "14px",
                            }}
                          />

                          {/* ⭐ RATING + REVIEWS FIXED */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <i
                                className="ph-fill ph-star"
                                style={{ color: "#ffb400" }}
                              />
                              <span
                                style={{ fontWeight: "600", fontSize: "14px" }}
                              >
                                {rating} ({reviews} reviews)
                              </span>
                            </div>

                            <span
                              style={{
                                color: "green",
                                fontWeight: "700",
                                fontSize: "14px",
                              }}
                            >
                              In Stock
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShopSection;
